import React from 'react';
import SegmentPageTemplate from '../components/SegmentPageTemplate';
import segmentConfigs from '../config/segmentConfigs';

const LocacaoSupermercado = () => {
  return <SegmentPageTemplate {...segmentConfigs.supermercado} />;
};

export default LocacaoSupermercado;